"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faLock = require("@fortawesome/pro-regular-svg-icons/faLock");

var _faLockOpen = require("@fortawesome/pro-regular-svg-icons/faLockOpen");

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var LockWrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin: 0 10px 0.5rem;\n    flex-grow: 1;\n\n    button {\n        height: 30px;\n        width: 38px;\n        padding: 0;\n        border-color: transparent;\n        background-color: #666;\n        color: #c0c0c0;\n    }\n"])));

var Lock = function Lock(_ref) {
  var locked = _ref.locked,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(LockWrapper, null, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-light",
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: locked ? _faLock.faLock : _faLockOpen.faLockOpen,
    size: "xs"
  })));
};

var _default = Lock;
exports["default"] = _default;